<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />
  
    <template v-if="skeletonLoader">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody@2, table-tfoot"
      >
      </v-skeleton-loader>
    </template>
    <template v-else>
      <!-- tabla -->
        <v-card>
          <v-card-title class="text-h6 text-md-h5 font-weight-bold primary--text">
            <v-row>
              <v-col 
                cols="12"
                sm="8"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      fab
                      small
                      exact
                      color="primary"
                      class="mr-4"
                      v-bind="attrs" 
                      v-on="on" 
                      @click="regresar"
                    >
                      <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                  </template>
                  <span>Regresar</span>
                </v-tooltip>
                Gestionar Cupos - {{ categoriaCompetencia.categoria }}
              </v-col>
              
              <v-col 
                cols="12"
                sm="4"
              >
                <div class="d-flex align-center">
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    append-icon="mdi-magnify"
                    label="Buscar Cupo"
                    class="mr-4"
                    v-model="searchTable"
                  >
                  </v-text-field>

                  <v-btn
                    exact
                    color="primary"
                    @click="open"
                  >
                    Registrar
                  </v-btn> 
                </div>
              </v-col>

              <v-col 
                cols="5"
                offset-sm="1"
                sm="2"
              >
                <p class="text-subtitle-1 font-weight-bold primary--text">
                  Total Cupos: {{ categoriaCompetencia.numero_participantes }}
                </p>
              </v-col>

              <v-col
                cols="5"
                sm="2"
              >
                <p 
                  :class="['text-subtitle-1', 'font-weight-bold', {'error--text': cuposDisponibles == 0}]"
                >
                  Disponibles: {{ cuposDisponibles }}
                </p>
              </v-col>
            </v-row>
          </v-card-title>

          <v-data-table
            fixed-header
            height="calc(100vh - 280px)"
            class="elevation-2"
            :headers="headersTable"
            :items="cupos"
            :search="searchTable"
            :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
          >
            <template v-slot:[`item.acciones`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }" >
                  <v-icon
                    color="primary"
                    v-bind="attrs" 
                    v-on="on"
                    class="mr-2"
                    @click="editar(item.id_cupo)"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
                <span>Actualizar</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }" >
                  <v-icon
                    color="error"
                    v-bind="attrs" 
                    v-on="on"
                    @click="alertaEliminar(item.id_cupo)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>

            <template v-slot:top>
              <v-dialog 
                persistent
                max-width="520px"
                v-model="dialogForm" 
              >
                <v-card :loading="loadingForm">
                  <v-card-title class="justify-center">
                    <p class="text-h5 font-weight-bold primary--text">
                      {{ formTitle }}
                    </p>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row justify="center">
                        <v-col 
                          cols="12"
                          md="10"
                        >
                          <v-form 
                            ref="form" 
                            v-model="form"
                          >
                            <v-text-field
                              outlined
                              dense
                              disabled
                              type="text"
                              label="Competencia"
                              v-model="competenciaSeleccionada"
                            >
                            </v-text-field>

                            <v-text-field
                              outlined
                              dense
                              disabled
                              type="text"
                              label="Categoria"
                              v-model="categoriaSeleccionada"
                            >
                            </v-text-field>

                            <v-text-field
                              outlined
                              dense
                              disabled
                              type="text"
                              label="Modalidad"
                              v-model="modalidadSeleccionada"
                            >
                            </v-text-field>

                            <v-text-field
                              outlined
                              dense
                              readonly
                              type="number"
                              label="Cupos Disponibles"
                              v-model="cupoDisponible"
                              :rules="cupoDisponibleReglas"
                            ></v-text-field>

                            <v-select
                              outlined
                              dense
                              :disabled="editedIndex !== -1"
                              label="Regional*"
                              :items="regionales"
                              item-value="id"
                              item-text="regional"
                              v-model="regional"
                              :rules="regionalReglas"
                            >
                            </v-select>

                            <v-select
                              outlined
                              dense
                              :disabled="editedIndex !== -1"
                              label="Centro de Formación*"
                              :items="centrosFormacion"
                              item-value="id"
                              item-text="centro_formacion"
                              v-model="centroFormacion"
                              :rules="centroFormacionReglas"
                            >
                            </v-select>

                            <v-text-field
                              outlined
                              dense
                              type="number"
                              label="Número de Participantes*"
                              v-model="numeroParticipantes"
                              :rules="numeroParticipantesReglas"
                            >
                            </v-text-field>

                            <v-text-field
                              outlined
                              dense
                              readonly
                              type="number"
                              label="Número de Grupos"
                              :value="cantidadGrupos"
                              :rules="cantidadGruposReglas"
                            >
                            </v-text-field>
                          </v-form>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                      text 
                      color="error" 
                      @click="close"
                    >
                      Cancelar
                    </v-btn>

                    <template v-if="editedIndex === -1">
                      <v-btn 
                        text 
                        exact
                        color="primary" 
                        @click="registrar"
                      > 
                        Registrar
                      </v-btn>
                    </template>
                    <template v-else>
                      <v-btn 
                        text 
                        exact
                        color="primary" 
                        @click="actualizar"
                      > 
                        Actualizar
                      </v-btn>
                    </template>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
          </v-data-table>
        </v-card>

        <!-- alerta eliminar -->
        <v-dialog 
          v-model="dialogDelete" 
          max-width="480px"
        >
          <v-card>
            <v-card-title class="justify-center text-h5">¿Esta seguro de eliminar el cupo?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn 
                text 
                color="primary" 
                @click="closeDelete"
              >
                Cancelar
              </v-btn>
              <v-btn 
                text 
                color="error" 
                @click="eliminar"
              > 
                OK
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </template>
  </div>
</template>

<script>
import Alert from '../../../components/admin/Alert.vue'

export default {
  data: () => ({
    skeletonLoader: true,
    searchTable: null,

    alert: false,
    alertType: '',
    alertTitle: '',
    alertMessage: '',

    headersTable: [
      {
        text: "Regional",
        value: "regional",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Centro de Formación",
        value: "centro_formacion",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "# Cupos",
        value: "numero_participantes",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },
    ],

    form: true,
    loadingForm: false,

    dialogForm: false,
    dialogDelete: false,

    idCupo: null,

    competenciaSeleccionada: '',

    categoriaSeleccionada: '',

    modalidadSeleccionada: '',
    modalidad: null,

    regional: null,
    regionalReglas: [
      (v) => !!v || "Seleccione una regional"
    ],

    centroFormacion: null,
    centroFormacionReglas: [
      (v) => !!v || "Seleccione un centro de formación"
    ],

    cupoDisponible: null,
    cupoDisponibleReglas: [
      (v) => v > 0 || "Cupo total de la categoria registrado",
    ],

    numeroParticipantes: null,
    numeroParticipantesReglas: [
      (v) => !!v || "Escriba un número de participantes",
    ],

    cantidadGruposReglas: [
      (v) => v > 0 || "El número de participantes no coincide con la modalidad"
    ],

    editedIndex: -1
  }),

  components: {
    Alert
  },

  mounted() {
    const categoriaCompetencia = {
      competencia_id: this.$route.params.id_competencia,
      categoria_id: this.$route.params.id_categoria
    }

    this.$store.dispatch("gestionarCupos", this.$route.params.id_competencia);
    this.$store.dispatch("detallesCategoriaCompetencia", categoriaCompetencia);
    this.$store.dispatch("crearRegionales");
    this.$store.dispatch("crearCentrosFormacion");
    
    setTimeout(() => {
      this.skeletonLoader = false
    }, 1000);
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Registrar Cupo' : 'Actualizar Cupo'
    },

    competencia() {
      return this.$store.getters.obtenerCompetencia;
    },

    categoriaCompetencia() {
      return this.$store.getters.obtenerCategoriaCompetencia;
    },

    regionales() {
      return this.$store.getters.obtenerRegionales;
    },

    centrosFormacion() {
      return this.$store.getters.obtenerCentrosFormacion(this.regional);
    },

    cupos() {
      return this.$store.getters.obtenerCupos(this.$route.params.id_categoria);
    },

    cupo() {
      return this.$store.getters.obtenerCupo;
    },

    cuposRegistrados() {
      return this.cupos.reduce((suma, cupo) => {
        return suma + cupo.numero_participantes
      }, 0);
    },

    cuposDisponibles() {
      return this.categoriaCompetencia.numero_participantes - this.cuposRegistrados
    },

    cantidadGrupos() {
      if (this.modalidad == 3) {
        if (this.numeroParticipantes % 3 == 0) {
          return this.numeroParticipantes
        }
        return 0;
      }
      else if (this.modalidad == 2) {
        if (this.numeroParticipantes % 2 == 0) {
          return this.numeroParticipantes
        }
        return 0;
      }

      return this.numeroParticipantes;
    }
  },

  watch: {
    dialogForm(val) {
      val || this.close()
    },

    dialogDelete(val) {
      val || this.closeDelete()
    },
  },

  methods: {
    open() {
      this.competenciaSeleccionada = this.categoriaCompetencia.competencia
      this.categoriaSeleccionada = this.categoriaCompetencia.categoria
      this.modalidadSeleccionada = this.categoriaCompetencia.modalidad
      this.modalidad = this.categoriaCompetencia.modalidad_id
      this.cupoDisponible = this.cuposDisponibles
      this.dialogForm = true
    },

    close() {
      this.$refs.form.reset();
      this.dialogForm = false
      this.editedIndex = -1
    },

    closeDelete() {
      this.dialogDelete = false
      this.editedIndex = -1
    },

    registrar() {
      if (this.$refs.form.validate()) {
        const cupo = {
          competencia_id:       this.$route.params.id_competencia,
          categoria_id:         this.$route.params.id_categoria,
          centro_formacion_id:  this.centroFormacion,
          numero_participantes: this.numeroParticipantes
        }

        this.loadingForm = true;

        this.$store.dispatch("registrarCupo", cupo)
        .then((response) => {
          if (response.status == "success") {
            this.close()
            this.loadingForm = false;

            const message     = response.message.split(",");
            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true;
            
            this.skeletonLoader = true

            this.$store.dispatch("gestionarCupos", this.$route.params.id_competencia);
            setTimeout(() => {
              this.alert = false;  
              this.skeletonLoader = false
            }, 2000);
          } 
          else {
            this.loadingForm  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";

            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }

            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }
        })
        .catch(() => {});
      }
    },

    editar(id) {
      this.editedIndex = 1;
      this.idCupo = id;

      this.competenciaSeleccionada = this.categoriaCompetencia.competencia
      this.categoriaSeleccionada = this.categoriaCompetencia.categoria
      this.modalidadSeleccionada = this.categoriaCompetencia.modalidad
      this.modalidad = this.categoriaCompetencia.modalidad_id
      this.cupoDisponible = this.cuposDisponibles

      this.$store.dispatch("detallesCupo", id);

      setTimeout(() => {
        const detalles = this.cupo

        this.regional = detalles.regional_id
        this.centroFormacion = detalles.centro_formacion_id
        this.numeroParticipantes = detalles.numero_participantes
      }, 1000);

      this.dialogForm = true;
    },

     actualizar() {
      if (this.$refs.form.validate()) {
        const cupo = {
          id_cupo:              this.idCupo,
          competencia_id:       this.$route.params.id_competencia,
          categoria_id:         this.$route.params.id_categoria,
          numero_participantes: this.numeroParticipantes
        };
        
        this.loadingForm = true;

        this.$store.dispatch("actualizarCupo", cupo)
        .then((response) => {
          if (response.status == "success") {
            this.close();
            this.loadingForm = false;
            
            const message     = response.message.split(",");
            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true;

            this.skeletonLoader = true

            this.$store.dispatch("gestionarCupos", this.$route.params.id_competencia);
            setTimeout(() => {
              this.alert = false
              this.skeletonLoader = false
            }, 2000)
          } 
          else {
            this.loadingForm  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";

            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }

            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }
        })
        .catch(() => {});
      }
    },

    alertaEliminar(id) {
      this.idCupo = id
      this.dialogDelete = true
    },

    eliminar() {
      this.dialogDelete = false

      this.$store.dispatch("eliminarCupo", this.idCupo)
      .then((response) => {
        if (response.status == "success") {
          const message     = response.message.split(",");
          this.alertType    = "success--text";
          this.alertTitle   = message[0];
          this.alertMessage = message[1];
          this.alert        = true;  

          this.skeletonLoader = true

          this.$store.dispatch("gestionarCupos", this.$route.params.id_competencia);
          setTimeout(() => {
            this.alert = false;  
            this.skeletonLoader = false
          }, 2000);
        } 
        else {
          this.loadingForm  = false
          this.alertType    = "error--text";
          this.alertTitle   = "Error";

          for (const error in response.message) {
            this.alertMessage = response.message[error][0]
          }

          this.alert = true;

          setTimeout(() => {
            this.alert = false
          }, 3000)
        }
      })
      .catch(() => {});
    },

    regresar() {
      this.$router.back()
    }
  }
};
</script>